import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { SHARED_NS, sharedCatalogues } from "@holigral/shared/i18n"
import { FALLBACK_LOCALE } from "./locales"
import enAdmin from "./locales/en/admin.json"
import enAssignment from "./locales/en/assignment.json"
import enAuth from "./locales/en/auth.json"
import enBrief from "./locales/en/brief.json"
import enCommon from "./locales/en/common.json"
import enContent from "./locales/en/content.json"
import enMatrix from "./locales/en/matrix.json"
import enMoney from "./locales/en/money.json"
import enMyprofiles from "./locales/en/myprofiles.json"
import enNotification from "./locales/en/notification.json"
import enQuestionnaire from "./locales/en/questionnaire.json"
import enTenant from "./locales/en/tenant.json"
import esMxAdmin from "./locales/es_MX/admin.json"
import esMxAssignment from "./locales/es_MX/assignment.json"
import esMxAuth from "./locales/es_MX/auth.json"
import esMxBrief from "./locales/es_MX/brief.json"
import esMxCommon from "./locales/es_MX/common.json"
import esMxContent from "./locales/es_MX/content.json"
import esMxMatrix from "./locales/es_MX/matrix.json"
import esMxMoney from "./locales/es_MX/money.json"
import esMxMyprofiles from "./locales/es_MX/myprofiles.json"
import esMxNotification from "./locales/es_MX/notification.json"
import esMxQuestionnaire from "./locales/es_MX/questionnaire.json"
import esMxTenant from "./locales/es_MX/tenant.json"

export const defaultNS = "common"

export const namespaces = [
  SHARED_NS,
  "common",
  "assignment",
  "brief",
  "questionnaire",
  "myprofiles",
  "admin",
  "notification",
  "auth",
  "tenant",
  "content",
  "money",
  "matrix",
] as const

export const resources = {
  en: {
    [SHARED_NS]: sharedCatalogues.en,
    common: enCommon,
    assignment: enAssignment,
    brief: enBrief,
    questionnaire: enQuestionnaire,
    myprofiles: enMyprofiles,
    admin: enAdmin,
    notification: enNotification,
    auth: enAuth,
    tenant: enTenant,
    content: enContent,
    money: enMoney,
    matrix: enMatrix,
  },
  // Locale codes use underscores, mirroring the backend (Locales::SUPPORTED)
  es_MX: {
    [SHARED_NS]: sharedCatalogues.es_MX,
    common: esMxCommon,
    assignment: esMxAssignment,
    brief: esMxBrief,
    questionnaire: esMxQuestionnaire,
    myprofiles: esMxMyprofiles,
    admin: esMxAdmin,
    notification: esMxNotification,
    auth: esMxAuth,
    tenant: esMxTenant,
    content: esMxContent,
    money: esMxMoney,
    matrix: esMxMatrix,
  },
} as const

void i18n.use(initReactI18next).init({
  resources,
  // Bootstrap default; the active locale is set per request by the public
  // $locale route (from the URL) or, in the app, from the signed-in user.
  lng: FALLBACK_LOCALE,
  // Underscored codes opt out of i18next's dash-based language detection,
  // so the regional → language → en chain is spelled out explicitly
  fallbackLng: {
    es_MX: ["es", "en"],
    es: ["en"],
    default: ["en"],
  },
  ns: [...namespaces],
  defaultNS,
  interpolation: {
    // React already escapes interpolated values
    escapeValue: false,
  },
})

export default i18n
